import { Drawer } from 'restaurantAdmin/components/drawer/Drawer';
import {
  ADD_TO_WAITLIST,
  OCCUPANT_DETAILS,
  SEAT_RESERVATION_GUEST,
  SEAT_WAITLIST_GUEST,
  SEAT_WALK_IN_FORM,
  SERVICE_OVERVIEW,
  VIEW_WAITLIST_ENTRY,
} from '../../utils/constants';
import { EditReservationDrawer } from './EditReservationDrawer';
import { useServiceSearchParams } from './hooks/useServiceSearchParams';
import { OccupantDetailsDrawer } from './occupantDetails/OccupantDetails';
import { ServiceOverviewDrawer } from './ServiceOverviewDrawer';
import { StatsDrawer } from './StatsDrawer';
import { SeatReservationGuestDrawer } from './sidePanel/reservations/SeatReservationGuestDrawer';
import { ServerDrawer } from './sidePanel/servers/ServerDrawer';
import { AddToWaitlistDrawer } from './sidePanel/waitList/AddToWaitlistDrawer';
import { SeatWaitlistGuestDrawer } from './sidePanel/waitList/SeatWaitlistGuestDrawer';
import { ViewWaitlistEntryDrawer } from './sidePanel/waitList/ViewWaitlistEntryDrawer';
import { ChangeWalkInSeatDrawer } from './walkIns/ChangeWalkInSeatDrawer';
import { SeatWalkInFormDrawer } from './walkIns/SeatWalkInFormDrawer';

type ServiceDrawerProps = {
  allowActivationOfSeatMode: boolean;
};

export const ServiceDrawer = (props: ServiceDrawerProps) => {
  const { allowActivationOfSeatMode } = props;
  const {
    drawerIsOpen,
    drawerType,
    closeDrawer,
    inSeatOccupantMode,
    inOccupantDetailsMode,
    inAddToWaitlistMode,
    inViewWaitlistEntryMode,
    inServerMode,
    inSeatWaitlistGuestMode,
    inChangeWalkInSeatMode,
    inSeatWalkInFormMode,
    inServiceOverviewMode,
    inSeatReservationGuestMode,
    inStatsMode,
    occupantTypeIsReservation,
  } = useServiceSearchParams();

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      closeDrawer();
    }
  };

  const mapDrawerParamToSide = () => {
    switch (drawerType) {
      case ADD_TO_WAITLIST:
      case OCCUPANT_DETAILS:
      case VIEW_WAITLIST_ENTRY:
      case SERVICE_OVERVIEW:
        return 'right';
      case SEAT_WAITLIST_GUEST:
      case SEAT_WALK_IN_FORM:
      case SEAT_RESERVATION_GUEST:
        return 'left';
      default:
        return 'right';
    }
  };

  return (
    <Drawer
      modal={false}
      disablePointerDismissal={inSeatOccupantMode}
      side={mapDrawerParamToSide()}
      open={drawerIsOpen}
      // This function will be called when the drawer is closed via a
      // `Dialog.Close` button provided as a child to this component.
      onOpenChange={handleOpenChange}
    >
      {inOccupantDetailsMode && (
        <>
          <OccupantDetailsDrawer
            allowActivationOfSeatMode={allowActivationOfSeatMode}
          />
          {occupantTypeIsReservation && <EditReservationDrawer />}
        </>
      )}

      {inAddToWaitlistMode && <AddToWaitlistDrawer />}

      {inViewWaitlistEntryMode && <ViewWaitlistEntryDrawer />}

      {inServerMode && <ServerDrawer />}

      {inSeatWaitlistGuestMode && <SeatWaitlistGuestDrawer />}

      {inChangeWalkInSeatMode && <ChangeWalkInSeatDrawer />}

      {inSeatWalkInFormMode && <SeatWalkInFormDrawer />}

      {inServiceOverviewMode && <ServiceOverviewDrawer />}

      {inSeatReservationGuestMode && <SeatReservationGuestDrawer />}

      {inStatsMode && <StatsDrawer />}
    </Drawer>
  );
};
